import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Record } from '../../../config/Record/RecordEntity';
import { recordActions, Auth } from '../../../config/configuration/react';
import { countries, NRM_SUB_STATUS, REACT_APP_API } from '../../../config';
import { t, numStr } from '../../../components/common/Translate';
import { currencySign } from '../../../Utils/currencySign';

export const useCounterAppraisal = ({ recordId }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const counterInspection = useSelector((state) => state.reduxRecords.data[recordId])?.counterInspection || {};
  const recordEntity = new Record(record);
  const isVisible =
    (recordEntity.CounterAppraisalIsVisibleNrm() ||
      recordEntity.CounterAppraisalIsVisibleB2b(Object.prototype.hasOwnProperty.call(counterInspection, 'recordId'))) &&
    !recordEntity.roleViewerAccessBloc(Auth.role(), 'counter-appraisal');
  const source = useSelector((state) => state.reduxRecords.data[recordId]?.sourceInfos?.source);
  const countryId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.countryId;
  const countryPosId = useSelector((state) => state.reduxRecords.data[recordId]?.carcheckPointOfSale?.countryId);
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const roleId = Auth.roleId();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  let downloadPdf = '';
  const newPdfUrl = counterInspection?.pdfUrl;
  let totals = [];
  const { waitingForCounterAppraisal } = NRM_SUB_STATUS;
  const country = countries[countryId];
  if (
    record?.record?.nrmStatusId > waitingForCounterAppraisal ||
    recordEntity.CounterAppraisalIsVisibleB2bFrevos(Object.prototype.hasOwnProperty.call(counterInspection, 'recordId'))
  ) {
    const { recordKey: rKey, recordId: rID } = counterInspection;
    const name = country === 'ES' ? 'informe_estadoVO' : 'rapport_d_inspection';
    downloadPdf = `${REACT_APP_API}/buyer/public/${source}/${rKey}/admin-documents/${rID}_${name}.pdf`;
    totals = [
      {
        label: t('internal'),
        value:
          counterInspection.mdCostsInternal !== null
            ? currencySign(numStr(counterInspection.mdCostsInternal), null, countryPosId)
            : '',
      },
      {
        label: t('external'),
        value:
          counterInspection.mdCosts !== null ? currencySign(numStr(counterInspection.mdCosts), null, countryPosId) : '',
      },
    ];
  }

  const showNewPdf = typeof newPdfUrl === 'string' && newPdfUrl.startsWith('https');
  const initialize = async (event) => {
    if (recordEntity.roleViewerAccessBloc(Auth.role(), 'counter-appraisal')) return;
    if (event?.target?.id !== 'theHref' && !isLoading) {
      if (!counterInspection?.recordId) setIsLoading(true);
      if (isVisible) {
        if (!Object.prototype.hasOwnProperty.call(counterInspection, 'recordId')) {
          const res = await dispatch(recordActions.createCounterInspection(recordId));
          if (res?.recordId) setIsLoading(false);
          window.location.replace(`/files/${res.recordId}`);
        } else {
          history.push(`/files/${counterInspection.recordId}`, {});
          window.location.replace(`/files/${counterInspection.recordId}`);
        }
      }
    }
  };

  return {
    isVisible,
    initialize,
    totals,
    downloadPdf,
    newPdfUrl,
    showNewPdf,
    counterInspection,
    isLoading,
    originId,
    roleId,
    isOpen,
    toggle,
  };
};
